import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    sdGlobalSearchBaseURL,newSdGroupApiBaseURL,newSdSupportSearchBaseURL,suggestionAPI
} from '../constants/index'


const initialState = {
    searchData: {
        searchResults: [],
        isLoading: false,
        error: null,
    },
    productCarousel: {
        products: [],
        isLoading: false,
        error: null,
    },
    filterResult: {
        filters: [],
        isLoading: false,
        error: null,
    },
    suggestion: {
        product: [],
        category: [],
        explore: [],
        support: [],
        suggestion: [],
        isLoading: false,
        nodata: false,
        noSuggestiondata: false
    }
};

export const getSearchResults = createAsyncThunk('searchLandingSlice/getSearchResults', async (query) => {
    try {
        return await axios.get(sdGlobalSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getFacetResults = createAsyncThunk('searchLandingSlice/getFacetResults', async (query) => {
    try {
        return await axios.get(sdGlobalSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getProducts = createAsyncThunk('searchLandingSlice/getProducts', async (query) => {
    try {
        return await axios.get(sdGlobalSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getSuggestion = createAsyncThunk('searchLandingSlice/getSuggestion', async (query) => {
    try {
        return await axios.get(newSdGroupApiBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getRealSuggestion = createAsyncThunk('searchLandingSlice/getRealSuggestion', async (query) => {
    try {
        return await axios.get(suggestionAPI + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

const searchLandingSlice = createSlice({
    name: 'searchLandingSlice',
    initialState,
    reducers: {
        resetAlerts: (state) => {
            state.search.error = '';
            state.search.isLoading = false;
            state.productCarousel.error = '';
            state.productCarousel.isLoading = false;
            state.filterResult.error = '';
            state.filterResult.isLoading = false;
            state.filterResult.nodata= false
            state.filterResult.noSuggestiondata= false
        },
        resetFacet: (state) => {
            state.filterResult = {};
        },
        resetSearchPage: (state) => {
            state.searchData = {
                searchResults: [],
                isLoading: false,
                error: null,
            };
        },
        resetProductList: (state) => {
            state.productCarousel = {    
                products: [],
                isLoading: false,
                error: null,};
        },
        resetSuggestion: (state) =>{
            state.suggestion.product=[]
            state.suggestion.category=[]
            state.suggestion.explore=[]
            state.suggestion.support=[]
            state.suggestion.suggestion=[]
            state.suggestion.isLoading=false
            state.suggestion.nodata=false
            state.suggestion.noSuggestiondata=false
        }
        
    },
    extraReducers: (builder) => {
        const handlePending = (state, action, sliceName, propName) => {
            if (action.type.startsWith(sliceName)) {
                state.searchData.isLoading = true;
                state.productCarousel.isLoading = true;
                state[propName] = { ...state[propName], isLoading: true, error: '' };
            }
        };

        const handleFulfilled = (state, action, sliceName, propName, payloadProp) => {
            if (action.type.startsWith(sliceName)) {
                state.searchData.isLoading = false;
                state.productCarousel.isLoading = false;
                state[propName] = { ...state[propName], isLoading: false, [payloadProp]: action.payload };
            }
        };

        const handleRejected = (state, action, sliceName, propName) => {
            if (action.type.startsWith(sliceName)) {
                state.searchData.isLoading = false;
                state.productCarousel.isLoading = false;
                state[propName] = { ...state[propName], isLoading: false, error: action.error.message };
            }
        };

        builder
            .addCase(getSuggestion.pending, (state) => {
                state.suggestion.isLoading = true;
            })
            .addCase(getSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                let data=action?.payload?.grouped_docs
                if(data?.Products){
                    state.suggestion.product=data?.Products.slice(0, 5)
                    // Populate categories
                    const categoryData = [];
                    data?.Products?.forEach((prod) => {
                    if (prod.productCategoryPagePath_s && prod.productCategoryTitle_s) {
                        categoryData.push({
                        url: prod.productCategoryPagePath_s,
                        title: prod.productCategoryTitle_s,
                        });
                    }
                    if (
                        prod.breadcrumbSubCategoryPagePath_s &&
                        prod.breadcrumbSubCategoryTitle_s
                    ) {
                        categoryData.push({
                        url: prod.breadcrumbSubCategoryPagePath_s,
                        title: prod.breadcrumbSubCategoryTitle_s,
                        });
                    }
                    });
                    const uniqueCategories = Array.from(
                    new Set(categoryData.map(JSON.stringify))
                    ).map(JSON.parse);
                    state.suggestion.category=uniqueCategories.slice(0, 5)
                }
                else{
                    state.suggestion.category=[]
                    state.suggestion.product=[]
                }
                if(data){
                    // Populate explore
                    const exploreData = [];
                    for (const key of ["Knowledge Base", "Community", "documents"]) {
                    if (data[key]) {
                        exploreData.push(...data[key]);
                    }
                    }
                    exploreData?.sort((a, b) => b.score - a.score);
                    state.suggestion.explore=exploreData.slice(0, 5)

                    // Populate support
                    const supportDocs = [];
                    for (const key of ["Support Products", "Software Downloads"]) {
                        if (data[key]) {
                            supportDocs.push(data[key][0]);
                        }
                        }
                    state.suggestion.support=supportDocs
                }
                else{
                    state.suggestion.explore=[]
                    state.suggestion.support=[]
                }
                if(
                    state.suggestion.category.length===0 
                    && state.suggestion.product.length===0
                    && state.suggestion.explore.length===0
                    && state.suggestion.support.length===0
                ){
                    state.suggestion.nodata=true
                }
                state.suggestion.isLoading = false;
            })
            .addCase(getSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.suggestion.isLoading = false;
                if(state.search){
                    state.search.error = action.error.message;
                }
                
            })
            .addCase(getRealSuggestion.pending, (state) => {
                state.suggestion.isLoading = true;
            })
            .addCase(getRealSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                let data=action?.payload
                if (data?.suggestions && data?.suggestions?.length > 0) {
                    state.suggestion.suggestion=data.suggestions.slice(0, 5)
                }
                else{
                    state.suggestion.noSuggestiondata=true
                }
                state.suggestion.isLoading = false;
            })
            .addCase(getRealSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.suggestion.isLoading = false;
                if(state.search){
                    state.search.error = action.error.message;
                }
                //state.search.error = action.error.message;
            })
            .addMatcher(
                action => action.type.endsWith('/pending'),
                (state, action) => {
                    handlePending(state, action, 'searchLandingSlice/getSearchResults', 'search');
                    handlePending(state, action, 'searchLandingSlice/getProducts', 'productCarousel');
                    handlePending(state, action, 'searchLandingSlice/getFacetResults', 'filterResult');
                }
            )
            .addMatcher(
                action => action.type.endsWith('/fulfilled'),
                (state, action) => {
                    handleFulfilled(state, action, 'searchLandingSlice/getSearchResults', 'search', 'searchResults');
                    handleFulfilled(state, action, 'searchLandingSlice/getProducts', 'productCarousel', 'products');
                    handleFulfilled(state, action, 'searchLandingSlice/getFacetResults', 'filterResult', 'filters');
                }
            )
            .addMatcher(
                action => action.type.endsWith('/rejected'),
                (state, action) => {
                    handleRejected(state, action, 'searchLandingSlice/getSearchResults', 'search');
                    handleRejected(state, action, 'searchLandingSlice/getProducts', 'productCarousel');
                    handleRejected(state, action, 'searchLandingSlice/getFacetResults', 'filterResult');
                }
            )
            
    }
})

export const { resetAlerts, resetFacet, resetSearchPage,resetProductList,resetSuggestion } = searchLandingSlice.actions
export default searchLandingSlice.reducer

